<template>
  <v-card class="grey lighten-5" flat>
    <v-card-title class="grey lighten-3">
      <h4 class="topic">Condições comerciais</h4>
    </v-card-title>
    <p class="info-color mt-3">Observações</p>
    <v-textarea class="mt-2" outline placeholder="Inserir observações" no-resize counter v-model="projeto.observacoes"
      rows="4">
    </v-textarea>
    <v-layout align-center>
      <v-flex d-flex xs12 sm6>
        <v-text-field type="number" label="Prazo de entrega" suffix="Dias" v-model="projeto.prazoEntrega"></v-text-field>
      </v-flex>
      <v-flex d-flex xs12 sm6>
        <v-text-field class="info-label-text" label="Valor venda direta" v-model="projeto.valorEUP" v-money="money"
          prefix="R$" :rules="currencyValueRules" ref="valorEUP">
        </v-text-field>
      </v-flex>
    </v-layout>

  </v-card>
</template>

<style type="text/css"></style>

<script>
import { mapGetters } from "vuex";

export default {
  name: "ProjectCommercialValue",
  computed: {
    ...mapGetters(["projeto", "parcelas", "valoresParcelas", "selectedProduct"]),
    valorFrete() {
      if (this.projeto.transportadora && this.projeto.transportadora.Taxa)
        return this.projeto.transportadora.Taxa

      return 0;
    }
  },
  methods: {
    currencyToNumber(value) {
      if (value)
        return Number(value.replace(/[d,.?!]+/g, "")) / 100;
      return 0;
    },
  },

  data() {
    return {
      showSimularSolAgora: false,
      logoImage: require('./icons/empty.svg'),
      logoFile: null,
      currencyValueRules: [
        v => (!!v && v != 0.0) || "Valor é obrigatório",
        v => (this.selectedProduct != null && this.currencyToNumber(v) >= (Math.round((this.selectedProduct.Preco + this.valorFrete) * 100) / 100)) ||
          'Valor deve ser maior que o valor unitário do produto',
        v => (this.selectedProduct != null && this.currencyToNumber(v) <= (Math.round((this.selectedProduct.PrecoEUP + this.valorFrete) * 100) / 100)) ||
          'Valor deve ser menor que o valor sugerido: ' + (this.selectedProduct != null ? (this.selectedProduct.PrecoEUP + this.valorFrete).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' }) : "0,00")
      ],
      money: {
        decimal: ",",
        thousands: ".",
        prefix: "",
        suffix: "",
        precision: 2,
        masked: false /* doesn't work with directive */,
      },
    }
  },

  watch: {
    "projeto.valorEUP": function () {
      let input = this.$refs.valorEUP.$el.querySelector("input");
      input.value = this.projeto.valorEUP;
    },
  }
}
</script>
